import {
  CLEAR_NATIVE_SESSION,
  SET_IS_IN_APP_REVIEW_SUPPORTED,
  SET_IS_MOBILE,
  SET_NATIVE_CLIENT_LIST,
  SET_NATIVE_SESSION,
  SET_NESTED_SCREEN,
} from './constants';

export function clearNativeSession() {
  return { type: CLEAR_NATIVE_SESSION };
}

export function setIsInAppReviewSupported(isSupported) {
  return {
    payload: { isSupported },
    type: SET_IS_IN_APP_REVIEW_SUPPORTED,
  };
}

export function setIsMobile({ isNativeMobile }) {
  return {
    payload: { isNativeMobile },
    type: SET_IS_MOBILE,
  };
}

export function setNativeClientList({ clients }) {
  return {
    payload: { clients },
    type: SET_NATIVE_CLIENT_LIST,
  };
}

export function setNativeSession(session) {
  return {
    payload: { session },
    type: SET_NATIVE_SESSION,
  };
}

export function setNestedScreen({ mainScreen, nestedScreen }) {
  return {
    payload: { mainScreen, nestedScreen },
    type: SET_NESTED_SCREEN,
  };
}
